import { ControlData } from '@/services/soaUpdatesService';
import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

/**
 * Accept changes to an SOA control with assignee and status updates
 * @param tenancyId The ID of the customer tenancy
 * @param controlId The ID of the control to update
 * @param assignee The assignee to set for the control
 * @param status The status to set for the control
 * @returns A promise that resolves when the update is complete
 */
export const acceptSOAControlChanges = async (
  tenancyId: string,
  controlId: string,
  assignee: string,
  status: string
): Promise<void> => {
  console.log('[soaControlsService] acceptSOAControlChanges via Thalassa API');
  try {
    await deiterateAPI.PUT(`/v1/soa/controls/${controlId}/accept`, {
      mode: 'cors',
      backend: 'thalassa',
      headers: { 'X-Tenancy-Id': tenancyId, 'Company-ID': tenancyId },
      body: JSON.stringify({ assignee, status })
    });
    console.log(`[soaControlsService] Successfully updated SOA control ${controlId}`);
  } catch (error) {
    console.error(`[soaControlsService] Error updating SOA control ${controlId}:`, error);
    throw error;
  }
};

/**
 * Save implementation plan for an SOA control
 * @param tenancyId The ID of the customer tenancy
 * @param controlId The ID of the control to update
 * @param implementationPlan The implementation plan text to save
 * @returns A promise that resolves when the update is complete
 */
export const saveSOAControlImplementationPlan = async (
  tenancyId: string,
  controlId: string,
  implementationPlan: string
): Promise<void> => {
  console.log('[soaControlsService] saveSOAControlImplementationPlan via Thalassa API');
  try {
    await deiterateAPI.PUT(`/v1/soa/controls/${controlId}/implementation-plan`, {
      mode: 'cors',
      backend: 'thalassa',
      headers: { 'X-Tenancy-Id': tenancyId, 'Company-ID': tenancyId },
      body: JSON.stringify({ implementationPlan })
    });
    console.log(`[soaControlsService] Successfully saved implementation plan for ${controlId}`);
  } catch (error) {
    console.error(`[soaControlsService] Error saving implementation plan for ${controlId}:`, error);
    throw error;
  }
};
